import { FormEvent, useState } from "react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { AuthShell } from "./auth-shell";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setMessage(null);
    try {
      const result = await api<{ message: string }>(
        "/api/auth/forgot-password",
        {
          method: "POST",
          body: JSON.stringify({ email }),
        },
      );
      setMessage(result.message);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Could not send reset email",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell
      title="Forgot Password"
      description="Enter your email and we’ll send a link to choose a new password."
      footer={
        <p>
          Remembered it? <Link to="/login">Back to Sign In</Link>
        </p>
      }
    >
      {message ? (
        <div className="space-y-4">
          <p className="text-sm text-rs-ink" role="status">
            {message}
          </p>
          <Button asChild className="rs-auth-submit rs-auth-submit-block">
            <Link to="/login">Return to Sign In</Link>
          </Button>
        </div>
      ) : (
        <form className="space-y-4" onSubmit={onSubmit}>
          <Input
            id="email"
            name="email"
            autoComplete="username"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            aria-label="Email"
          />
          {error ? (
            <p className="text-sm text-rs-danger" role="alert">
              {error}
            </p>
          ) : null}
          <Button
            className="rs-auth-submit rs-auth-submit-block"
            type="submit"
            disabled={busy}
          >
            {busy ? "Sending…" : "Send Reset Link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
